/* eslint-disable no-param-reassign */
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { StepperState } from '../../../../components/stepper/stepper.interfaces';
import { RootState } from '../../../../state/hooks';

interface Stepper extends StepperState {
  wasIncremented: boolean;
}

const initialState: Stepper = {
  activeStep: 1,
  nextEnabled: false,
  backEnabled: false,
  wasIncremented: false,
};

export const takeAssessmentStepperSlice = createSlice({
  name: 'takeAssessmentStepperSlice',
  initialState,
  reducers: {
    resetStepper: (state) => {
      state.activeStep = initialState.activeStep;
      state.nextEnabled = initialState.nextEnabled;
      state.backEnabled = initialState.nextEnabled;
    },
    incrementActiveStep: (state) => {
      state.activeStep += 1;
      state.wasIncremented = true;
    },
    incrementActiveStepBy: (state, action: PayloadAction<number>) => {
      state.activeStep += action.payload;
      state.wasIncremented = true;
    },
    decrementActiveStep: (state) => {
      state.activeStep -= 1;
      state.wasIncremented = false;
    },
    decrementActiveStepBy: (state, action: PayloadAction<number>) => {
      state.activeStep -= action.payload;
      state.wasIncremented = false;
    },
    setNextEnabled: (state, action: PayloadAction<boolean>) => {
      state.nextEnabled = action.payload;
    },
    setBackEnabled: (state, action: PayloadAction<boolean>) => {
      state.backEnabled = action.payload;
    },
    setActiveStep: (state, action: PayloadAction<number>) => {
      state.activeStep = action.payload;
    },
  },
});

export const selectActiveStep = (state: RootState): number => {
  return state.takeAssessmentStepperReducer.activeStep;
};

export const selectNextEnabled = (state: RootState): boolean => {
  return state.takeAssessmentStepperReducer.nextEnabled;
};

export const selectBackEnabled = (state: RootState): boolean => {
  return state.takeAssessmentStepperReducer.backEnabled;
};

export const selectWasIncremented = (state: RootState): boolean => {
  return state.takeAssessmentStepperReducer.wasIncremented;
};

export const StepperSelectors = {
  selectActiveStep,
  selectNextEnabled,
  selectBackEnabled,
};

export const StepperDispatchers = takeAssessmentStepperSlice.actions;
